import { AssistantChatBlock, AssistantChatMessage, AssistantChatReply } from '../../interfaces/assistant-chat.interface';

export interface AssistantChatTurn {
  role: 'user' | 'assistant';
  content: string;
}

export const SECTIONS_JSON_START = '[[SECTIONS_JSON_START]]';
export const SECTIONS_JSON_END = '[[SECTIONS_JSON_END]]';

export function conversationOf(thread: AssistantChatMessage[]): AssistantChatTurn[] {
  return thread.flatMap((message, index): AssistantChatTurn[] => {
    const question = message.role === 'user' ? (message.text || '').trim() : '';
    const answer = thread[index + 1];
    if (!question || answer?.role !== 'assistant' || answer.meta?.failed || !answer.blocks?.length) {
      return [];
    }

    return [
      { role: 'user', content: question },
      { role: 'assistant', content: `${SECTIONS_JSON_START}${JSON.stringify({ sections: answer.blocks })}${SECTIONS_JSON_END}` },
    ];
  });
}

export function replyFrom(response: any): AssistantChatReply {
  const requestId = typeof response?.request_id === 'string' ? response.request_id : undefined;
  const caveats: string[] = Array.isArray(response?.caveats)
    ? response.caveats.filter((caveat: unknown): caveat is string => typeof caveat === 'string')
    : [];
  const sections: AssistantChatBlock[] = Array.isArray(response?.sections) ? response.sections : [];
  if (sections.length) {
    return { blocks: sections, requestId, caveats };
  }

  const summary = (response?.summary || '').trim();
  return { blocks: summary ? [{ type: 'text', body: summary }] : [], requestId, caveats };
}
